import React, {Component} from 'react';

class DeviceDINMini extends Component {
  render() {
    const {device, color} = this.props
    return <div>
      <div className="value"><span className="number"> </span></div>
      <span style={{
          color: color
        }}>{device.Name}</span>
    </div>
  }
}

export default DeviceDINMini;



// WEBPACK FOOTER //
// ./src/components/DeviceDINMini.js